var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[ _vm.$route.name ? _vm.$route.name.toLowerCase() : 'default' ] = true, _obj ),attrs:{"id":"app"}},[_c('ynk-layout',[_c('transition',{attrs:{"mode":"out-in","css":false,"appear":""},on:{"enter":_vm.getAnimateIn,"leave":_vm.getAnimateOut}},[_c('router-view',{key:_vm.$route.path,ref:"currentView"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }